var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicCanciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCE7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FBCFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noteGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DB2777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9D174D"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 30)",
    filter: "drop-shadow(0px 3px 2px rgba(157, 23, 77, 0.25))"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8,-15 L 14,-20 L 14,-14 L -8,-9 Z",
    fill: "url(#noteGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -9,
    width: 3,
    height: 20,
    fill: "url(#noteGrad)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -12,
    cy: 11,
    rx: 6,
    ry: 4.5,
    fill: "url(#noteGrad)",
    transform: "rotate(-20 -12 11)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: -14,
    width: 3,
    height: 20,
    fill: "url(#noteGrad)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7,
    cy: 6,
    rx: 6,
    ry: 4.5,
    fill: "url(#noteGrad)",
    transform: "rotate(-20 7 6)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18, -4) scale(0.65)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -2,-5 C 3,-5 3,3 0,5",
    fill: "none",
    stroke: "#F43F5E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -4.5,
    cy: 5,
    rx: 3.5,
    ry: 2.5,
    fill: "#F43F5E",
    transform: "rotate(-20 -4.5 5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16, -10) scale(0.5)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -2,-5 C 3,-5 3,3 0,5",
    fill: "none",
    stroke: "#F43F5E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -4.5,
    cy: 5,
    rx: 3.5,
    ry: 2.5,
    fill: "#F43F5E",
    transform: "rotate(-20 -4.5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicCanciones);
export default __webpack_public_path__ + "static/media/topic_canciones.6c0ebde9b9fb2b03715e767e97ac20a1.svg";
export { ForwardRef as ReactComponent };